module.exports = __webpack_public_path__ + "static/media/1.a3e5a825.jpg";